import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function PermitDescriptionBox({
  description,
  title = "Permit Description",
  titleClassName = "mb-3 text-md font-semibold text-slate-800",
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsClamp, setNeedsClamp] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (!textRef.current) return;
      const el = textRef.current;
      const isMobile = window.innerWidth < 640;
      if (!isMobile) {
        setNeedsClamp(false);
        return;
      }
      const computed = window.getComputedStyle(el);
      const lineHeight = parseFloat(computed.lineHeight) || 24;
      const threeLinesHeight = lineHeight * 3;
      const exceeds = el.scrollHeight > threeLinesHeight + 4;
      setNeedsClamp(exceeds);
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [description]);

  if (!description || !String(description).trim()) return null;

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 sm:p-6 shadow-sm">
      <h3 className={titleClassName}>{title}</h3>
      <div className="rounded-lg border border-orange-100 bg-orange-50/40 p-4">
        <p
          ref={textRef}
          className={`whitespace-pre-wrap break-words text-sm leading-6 text-slate-700 text-justify transition-all ${
            !isExpanded && needsClamp
              ? "line-clamp-3 sm:line-clamp-none"
              : ""
          }`}
          style={{
            textAlign: "justify",
            textJustify: "inter-word",
            textAlignLast: "left",
          }}
        >
          {description}
        </p>

        {needsClamp && (
          <button
            type="button"
            onClick={() => setIsExpanded((prev) => !prev)}
            className="mt-2.5 inline-flex items-center gap-1 text-xs font-semibold text-orange-600 hover:text-orange-700 transition-colors sm:hidden cursor-pointer touch-manipulation"
          >
            {isExpanded ? (
              <>
                <span>Read less</span>
                <ChevronUp className="h-3.5 w-3.5" />
              </>
            ) : (
              <>
                <span>Read more</span>
                <ChevronDown className="h-3.5 w-3.5" />
              </>
            )}
          </button>
        )}
      </div>
    </section>
  );
}
